import { useRelevantQueryParams } from '@frontend/common';
import { useModals } from '@frontend/modal';
import { ReportClient } from '@frontend/report/api';
import { Report, ReportType } from '@frontend/report/types';
import { useAccountRepository } from '@frontend/repository';
import { useEffect, useMemo, useState } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';

import { useAppDispatch } from '../../../redux/store';

export const REPORT_MODAL_ID = 'vending-transactions-report-modal';

const FILTER_KEYS = ['product', 'user', 'cost_center', 'spot_id', 'user_id', 'product_id', 'cost_center_id', 'after', 'before'];

export const useVendingTransactions = () => {
    const dispatch = useAppDispatch();
    const location = useLocation();
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const { currentAccount } = useAccountRepository();
    const [report, setReport] = useState<Report | null>(null);
    const { openModal, closeModal } = useModals();
    const exportData: { [key: string]: any } = { ...useRelevantQueryParams(['tab']) };

    const filterKey = useMemo(() => {
        return FILTER_KEYS.map((key) => `${key}=${searchParams.getAll(key).sort().join(',')}`).join('&');
    }, [searchParams]);

    useEffect(() => {
        ReportClient.fetchReports({ type: ReportType.VENDING_TRANSACTIONS, account_id: currentAccount }).then((res) => {
            if (res.results.length > 0) {
                setReport(res.results[0]);
            }
        });
    }, [currentAccount]);

    return {
        dispatch,
        currentAccount,
        report,
        openModal,
        closeModal,
        exportData,
        location,
        navigate,
        filterKey
    };
};
